let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("huG6o")).then(() => parcelRequire('39Yji'));